import AuthorOne from '../../assets/image/crypto/author-1.jpg';
import AuthorTwo from '../../assets/image/crypto/author-2.jpg';
import AuthorThree from '../../assets/image/crypto/author-3.jpg';
import AuthorFour from '../../assets/image/crypto/author-4.jpg';
import FEATURE1 from '../../assets/image/crypto/tf1.svg';
import FEATURE2 from '../../assets/image/crypto/tf2.svg';
import FEATURE3 from '../../assets/image/crypto/tf3.svg';
import FEATURE4 from '../../assets/image/crypto/tf4.svg';
import PROOF1 from '../../assets/image/crypto/proof1.svg';
import PROOF2 from '../../assets/image/crypto/proof2.svg';
import PROOF3 from '../../assets/image/crypto/proof3.svg';
import PROOF4 from '../../assets/image/crypto/proof4.svg';
import PROOF5 from '../../assets/image/crypto/proof5.svg';
import PROOF6 from '../../assets/image/crypto/proof6.svg';
import JACKPOTIMG from '../../assets/image/crypto/jackpot.svg';
import BETA1 from '../../assets/image/crypto/beta-1.svg';
import BETA2 from '../../assets/image/crypto/beta-2.svg';
import BETA3 from '../../assets/image/crypto/beta-3.svg';

export const HEADERS = [
  {
    header: 'Generate 10x More Income From Your YouTube Traffic.',
    subtext: 'Create a site offering digital courses, eCommerce products, bleeding-edge content, & more.',
  }
]

export const MENU_ITEMS = [
  {
    label: 'Home',
    path: '#banner_section',
    offset: '0',
  },
  // {
  //   label: 'Feature',
  //   path: '#trusted',
  //   offset: '0',
  // },
  {
    label: 'Feature',
    path: '#control',
    offset: '-10',
  },

  {
    label: 'Pricing',
    path: '#featureslider',
    offset: '-10',
  },
  {
    label: 'Contact Us',
    path: '#footerSection',
    offset: '380',
  },
];

export const TESTIMONIALS = [
  {
    review:
      'Was so easy to quickly create a site to expand what I can offer to my viewers. Allows me to expand what I create & make more income.',
    name: 'Justin McCarthy',
    designation: 'YouTube Creator at Magic Mileage',
    avatar: `${AuthorTwo}`,
  },
  {
    review:
      'My Limerise site has enabled me to quit my job & focus on generating YouTube content & online courses full-time.',
    name: 'Hays Stanford',
    designation: 'Video Instructor at HaysStanford.com',
    avatar: `${AuthorOne}`,
  },
  {
    review:
      'To be entirely honest, I make way more from my Limerise site than I do from YouTube ads. This allows me to source & sell actual products to my viewers.',
    name: 'Amanda Nowakowski',
    designation: 'Painting Teacher at PassionPaints Video, Inc.',
    avatar: `${AuthorThree}`,
  },
  {
    review:
      'Limerise has enabled me to finally have an eCommerce store that has I can integrate my video content into. I love it!',
    name: 'Christi Schneider',
    designation: 'Content Creator at Media For Maynor',
    avatar: `${AuthorFour}`,
  },
];
export const TRANSACTIONS_FEATURE = [
  {
    image: FEATURE1,
    title: 'Create Payment Address',
    des: 'Provide your payout wallet address and callback URL to PayBear API.',
  },
  {
    image: FEATURE2,
    title: 'Ask for Payment',
    des: 'Show your customer the wallet address as well as the payment amount.',
  },
  {
    image: FEATURE3,
    title: 'Get Paid',
    des: 'Payment is sent to the payout wallet immediately.',
  },
  {
    image: FEATURE4,
    title: 'Get Payment Notification.',
    des:
      'Callbacks are sent to the URL you specified. You can process customer order',
  },
];
export const PROOFS_FEATURE = [
  {
    image: PROOF1,
    title: 'Instant trading',
    des: 'Never miss a price swing.',
  },
  {
    image: PROOF2,
    title: 'No hidden fees',
    des: 'know our fees upfront.',
  },
  {
    image: PROOF3,
    title: 'Secure storage',
    des: 'Sleep with peace of mind.',
  },
  {
    image: PROOF4,
    title: 'Systematic trading',
    des: 'History intraday market.',
  },
  {
    image: PROOF5,
    title: 'Network Effect',
    des: 'Casinos contribute 1%.',
  },
  {
    image: PROOF6,
    title: 'Bigger Rewards',
    des: 'Players are incentivized.',
  },
];
export const SCALABLE_FEATURE = [
  {
    image: JACKPOTIMG,
    title: 'Daily Jackpot',
    des: '35000 CLV',
  },
  {
    image: JACKPOTIMG,
    title: 'Weekly Jackpot',
    des: '250000 CLV',
  },
  {
    image: JACKPOTIMG,
    title: 'Monthly Jackpot',
    des: '4999697 CLV',
  },
  {
    image: JACKPOTIMG,
    title: 'Yearly Jackpot',
    des: '300245785000 CLV',
  },
];

export const BETA_FEATURE = [
  {
    image: BETA1,
    title: 'Weekly Deposits',
    des: 'Get your money, now.',
  },
  {
    image: BETA2,
    title: '24/7 Support',
    des: 'Always here for you.',
  },
  {
    image: BETA3,
    title: 'Secure Payments',
    des: '100% safe transactions.',
  },
];

export const menuWidget = [
  {
    id: 1,
    title: 'About Us',
    menuItems: [
      {
        id: 1,
        url: '#',
        text: 'Support Center',
      },
      {
        id: 2,
        url: '#',
        text: 'Customer Support',
      },
      {
        id: 3,
        url: '#',
        text: 'About Us',
      },
      {
        id: 4,
        url: '#',
        text: 'Careers',
      },
      // {
      //   id: 5,
      //   url: '#',
      //   text: 'Popular Campaign',
      // },
    ],
  },
  {
    id: 2,
    title: 'Our Information',
    menuItems: [
      // {
      //   id: 1,
      //   url: '#',
      //   text: 'Return Policy',
      // },
      {
        id: 2,
        url: '#',
        text: 'Privacy Policy',
      },
      {
        id: 3,
        url: '#',
        text: 'Terms & Conditions',
      },
      {
        id: 4,
        url: '#',
        text: 'Site Map',
      },
      {
        id: 5,
        url: '#',
        text: 'Copyright',
      },
      // {
      //   id: 5,
      //   url: '#',
      //   text: 'Store Hours',
      // },
    ],
  },
  {
    id: 3,
    title: 'My Account',
    menuItems: [
      {
        id: 1,
        url: '#',
        text: 'Press inquiries',
      },
      // {
      //   id: 2,
      //   url: '#',
      //   text: 'Social media directories',
      // },
      // {
      //   id: 3,
      //   url: '#',
      //   text: 'Images & B-roll',
      // },
      {
        id: 4,
        url: '#',
        text: 'Permissions',
      },
      {
        id: 5,
        url: '#',
        text: 'Billing',
      },
    ],
  },
];
export const Language_NAMES = [
  {
    label: 'English',
    value: 'eng',
  },
  // {
  //   label: 'Chinese',
  //   value: 'chinese',
  // },
  // {
  //   label: 'Indian',
  //   value: 'indian',
  // },
];
